import React from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";

const JustifyBetweenRow = ({ children }) => {
  return <div className="flex justify-between p-3">{children}</div>;
};

export const justifyBetweenRowControls = {
  children: {
    propType: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element,
      PropTypes.string,
    ]),
    description: "Card content",
    disable: true,
  },
};

JustifyBetweenRow.propTypes = AppUtils.getPropTypeFromControls(
  justifyBetweenRowControls,
);

export default JustifyBetweenRow;
